import { Link } from 'react-router-dom';
import moment from 'moment';
import { imgURL } from '../../Config';
import './EventDetails.css';

const EventCard = ({ event, lookupData, register }) => {
  const formatDate = (date) => moment(date).format('DD MMM YYYY');

  return (
    <div className="col">
      <div className="card eventcard shadow-sm h-100 hover-shadow transition">
        <img
          src={imgURL + 'event_banners/' + event.banner}
          alt={event.title}
          className="card-img-top"
          style={{ height: '300px', objectFit: 'cover' }}
        />
        <div className="card-body d-flex flex-column justify-content-between">
          <div>
            <h6 className="fw-bold event-clamp-text">{event.title}</h6>
            <div className="row text-sm event-info">
              <p><b className="event_time">Date:</b> {' '}
                {formatDate(event.event_date) === formatDate(event.event_end_date)
                  ? formatDate(event.event_date)
                  : `${formatDate(event.event_date)} to ${formatDate(event.event_end_date)}`}</p>
              <p><b className="event_time">Time :</b> {event.event_time} - {event.event_end_time}</p>
              <p><b className="event_time">Event Type :</b> {lookupData?.find((m) => m?.Flag === '10' && event?.mode == m?.LookupCode)?.LookupValue}</p>
              {event.entry_type == 1 && <p><b className="event_time">Entry Type :</b> Paid</p>}
            </div>
          </div>
          <div className="text-center">
            <Link to={`/eventdetails/${event.id}`} state={{ register }} className="btn btn-primary w-100">
              View Full Details
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default EventCard;
